import { Link } from 'gatsby'
import React from 'react'

import { HBox } from 'src/ui/layout'
import { Hero } from 'src/ui/organisms'
import { Body, Header } from 'src/ui/typography'
import { TSliderItem } from '../hero-block/types'

type Props = {
  images: TImages
  sliderItems: TSliderItem[]
}

export const Rest: React.FC<Props> = ({ images, sliderItems }) => (
  <Hero
    title="Жизнь вне офиса"
    adornment={true}
    label="ОТДЫХ"
    sliderItems={sliderItems}
    objectPosition="top left"
  >
    <HBox />
    <Header size="h5" as="h3">
      Развлекаемся
    </Header>
    <HBox height={8} />
    <Body>
      Сотрудники KODE любят проводить время друг с&nbsp;другом, поэтому
      регулярно встречаются за пределами офиса:&nbsp;ходят в&nbsp;кино, на на
      концерты и&nbsp;лекции, посещают мастер-классы.
    </Body>
    <HBox height={8} />
    <Body>
      <Link to="/fun/">Подробнее</Link>
    </Body>

    <HBox height={24} />

    <Header size="h5" as="h3">
      Занимаемся творчеством
    </Header>
    <HBox height={8} />
    <Body>
      Наша музыкальная кавер-группа «Ласковый&nbsp;дедлайн» выступает на
      корпоративах&nbsp;и не только.
    </Body>
    <HBox height={8} />
    <Body>
      <Link to="/fun/#band">Подробнее</Link>
    </Body>

    <HBox height={24} />

    <Header size="h5" as="h3">
      Путешествуем
    </Header>
    <HBox height={8} />
    <Body>
      Исследуем туристические маршруты вокруг Калининграда. А дважды в год
      отправляемся заграницу вместе с коллегами. Например, мы видели китов в
      Баренцевом море, угощались восточными сладостями в Марокко и гуляли по
      старым улицам Дербента
    </Body>
    <HBox height={8} />
    <Body>
      <Link to="/fun/#travel">Подробнее</Link>
    </Body>
  </Hero>
)
